import {Injectable} from '@angular/core';

import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {AccountService} from "../auth/account.service";

@Injectable({
    providedIn: 'root'
})
export class SendInBlueApiService {

    public resourceUrl = environment.SERVER_API_URL + 'services/configurator/api/sib';

    public listTestEmail = '';

    constructor(
        protected http: HttpClient,
        private readonly accountService: AccountService
    ) {
        this.accountService.getAuthenticationState().subscribe(user => {
            this.listTestEmail = user?.email;
        });
    }

    getUrl0penSmtpTemplate(id: string) {
        return `https://app.brevo.com/templates/email/edit/${id}`;
    }

    openSmtpTemplate(id: string) {
        const url = this.getUrl0penSmtpTemplate(id);
        window.open(url);
    }

    newSmtpTemplate() {
        const url = 'https://app.brevo.com/templates/email/create';
        window.open(url);
    }
}
